<template>
    <span class="search-outline-icon">
        <svg
            width="14"
            height="14"
            viewBox="0 0 24 24"
            fill="none"
            :stroke="stroke"
            stroke-width="2"
            stroke-linecap="round"
            stroke-linejoin="round"
            xmlns="http://www.w3.org/2000/svg"
        >
            <path d="m21 21-4.34-4.34" />
            <circle cx="11" cy="11" r="8" />
        </svg>
    </span>
</template>

<script>
export default {
    name: 'IconSearchOutline',
    props: {
        stroke: {
            type: String,
            default: 'currentColor',
        },
    },
};
</script>

<style scoped>
/* See IconPlayOutline.vue for why the wrapper needs to be a flex container
   itself: a plain <span> as a flex/grid item doesn't center its own
   inline-level svg content vertically. */
.search-outline-icon {
    display: inline-flex;
    align-items: center;
}
</style>
